import { FC, useState } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { TelephonicAssignmentModal } from './TelephonicAssignmentModal';
import { TelephonicResetModal } from './TelephonicResetModal';
import { typeTelephonicTerritory, typeUser } from '@monorepo/models';
import { useNavigate } from 'react-router';

type propsType = {
    showOpened: boolean;
    t: typeTelephonicTerritory;
    users: typeUser[];
};

export const TelephonicBody: FC<propsType> = ({ showOpened, t, users }) => {
    const [showAssignmentModal, setShowAssignmentModal] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const navigate = useNavigate();

    return (
        <tr className={t.opened && !showOpened ? 'd-none' : ''}>
            {showAssignmentModal &&
                <TelephonicAssignmentModal
                    closeModal={() => setShowAssignmentModal(false)}
                    t={t}
                    users={users}
                />
            }
            {showResetModal &&
                <TelephonicResetModal
                    closeModal={() => setShowResetModal(false)}
                    t={t}
                />
            }
            <td className={'pointer'} onClick={() => navigate(`/telefonica/${t.territoryNumber}`)}>
                {t.territoryNumber}
            </td>
            <td style={{ maxWidth: '350px' }}>
                {!!users.filter(u => u.phoneAssignments?.includes(t.number))?.length ?
                    users.filter(u => u.phoneAssignments?.includes(t.number)).map((u, i, t) =>
                        <div key={u.id} className={i === t.length - 1 ? '' : 'mb-1'}>
                            {u.name} {u.lastName}
                        </div>
                    )
                    :
                    '-'
                }
            </td>
            <td className={'text-center'}>
                <button className={'btn btn-general-blue'} onClick={() => setShowAssignmentModal(true)}>
                    CAMBIAR
                </button>
            </td>
            <td className={`text-center ${t.opened ? 'bg-success' : 'bg-danger'} `}>
                {t.opened ? 'ABIERTO' : 'CERRADO'}
            </td>
            <td className={'text-center'}>
                {t.total}
            </td>
            <td className={'text-center'}>
                {t.left}
            </td>
            <td className={'text-center'}>
                {t.unsubscribed}
            </td>
            <td className={'text-center'}>
                {t.last}
            </td>
            <td className={'text-center'}>
                {t.stateOfTerritory.resetDates.length ?
                    generalHelpers.GetDateStringFromDate(new Date(t.stateOfTerritory.resetDates.sort((d1, d2) => d2.date - d1.date)[0]!.date))
                    :
                    '-'
                }
            </td>
            <td className={'text-center'}>
                <button className={'btn btn-general-blue'} onClick={() => setShowResetModal(true)}>
                    RESETEAR
                </button>
            </td>
        </tr>
    )
}
